import {ColorPalette} from 'theme';
import type {DotProps} from './Dot';
import {Dot} from './Dot';

type Props = Omit<DotProps, 'color'>;

export const WarningDot: React.FC<Props> = props => (
  <Dot color={ColorPalette.warning} {...props} />
);
